import type { CallMediaUrls } from "@repo/app-types/api/interview";
import type { BasicContact } from "@repo/app-types/entities/contact";
import type {
  Interview,
  InterviewUpdate,
} from "@repo/app-types/entities/interview";
import { api } from "../redux.js";

const interviewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    interviewCallMediaUrls: builder.query<
      CallMediaUrls[],
      { projectId: string; interviewId: string },
      { data: { calls: CallMediaUrls[] } }
    >({
      query: ({ projectId, interviewId }) => ({
        method: "POST",
        url: `/projects/${encodeURIComponent(projectId)}/interviews/${encodeURIComponent(interviewId)}/generate-call-media-urls`,
      }),
      transformResponse: (response) => response.data.calls,
    }),
    importParticipants: builder.mutation<
      Interview[],
      { projectId: string; contacts: BasicContact[] },
      { data: { interviews: Interview[] } }
    >({
      query: ({ projectId, contacts }) => ({
        method: "POST",
        url: `/projects/${encodeURIComponent(projectId)}/participants/import`,
        body: { contacts },
      }),
      transformResponse: (response) => response.data.interviews,
    }),
    bulkUpdateInterviews: builder.mutation<
      Interview[],
      { projectId: string; interviewIds: string[]; updates: InterviewUpdate },
      { data: { interviews: Interview[] } }
    >({
      query: ({ projectId, interviewIds, updates }) => ({
        method: "PATCH",
        url: `/projects/${encodeURIComponent(projectId)}/interviews/bulk`,
        body: { interview_ids: interviewIds, updates },
      }),
      transformResponse: (response) => response.data.interviews,
    }),
  }),
});

export const {
  useInterviewCallMediaUrlsQuery,
  useImportParticipantsMutation,
  useBulkUpdateInterviewsMutation,
} = interviewApi;

export { interviewApi };
